import React from 'react';
import { Checkbox } from 'rsuite';
import { ButtonComponent } from '../ButtonComponent';

interface IRenderExtraFooterProps {
	statusFilter: string [];
	allValue: string [];
	handleCheckAll: (value: any, checked: boolean) => void;
	handleSave?: () => void | Promise<void>;
}

export const RenderExtraFooter = (props: IRenderExtraFooterProps): JSX.Element => {
	const { statusFilter, allValue, handleCheckAll, handleSave } = props;
	return (
		<div className="footer-styles">
			<Checkbox
				inline
				indeterminate={statusFilter?.length > 0 && statusFilter?.length < allValue?.length}
				checked={statusFilter?.length === allValue?.length}
				onChange={handleCheckAll}
				className="me-3"
			>
				Check all
			</Checkbox>

			{
				handleSave && (
					<div className="mx-3">
						<ButtonComponent
							buttonName="Ok"
							onButtonClick={handleSave}
							additionalClass="btn-sm no-letter-spacing py-2 d-block w-100"
						/>
					</div>
				)
			}

		</div>
	);
};
